const jobTypesFilterOptions = [
    {
      value: "INTERNSHIP",
      label: "Internship"
    },
    {
      value: "CONTRACT",
      label: "Contract"
    },
    {
      value: "VOLUNTEER",
      label: "Volunteer"
    },
    {
      value: "FULL_TIME",
      label: "Full time"
    },
    {
      value: "PART_TIME",
      label: "Part time"
    }
  ]

export default jobTypesFilterOptions